import { Input, MyTableComponent, TableModelRow } from "components"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "theme-ui"
import { useDeviceSupplyDataQuery } from "../../store/Features/devices/devicesSupplyData-api-slice"
import tittle from "./Tittle.png"
import selectIcon from "./selecticon.png"

import { INotificationPointElement, ISupplyData } from "@types"
export const ConfigurationData = () => {
 const { t } = useTranslation("translation")
 const { data, isLoading } = useDeviceSupplyDataQuery()

 const [allData, setAllData] = useState<ISupplyData[]>([])
 const [selectedData, setSelectedData] = useState<INotificationPointElement[]>([])
 const [currentData, setCurrentData] = useState<INotificationPointElement[]>([])
 const [currentIndex, setCurrentIndex] = useState<number>(0)
 const [popup, setPopup] = useState<boolean>(false)
 const [modelData, setModelData] = useState<INotificationPointElement>()
 const [serverDeviceName, setServerDeviceName] = useState<string>()
 const columns = [
  {
   Header: "total_version_buildnumber",
   accessor: "total_version_buildnumber",
  },
  { Header: t("timestamp"), accessor: "timestamp" },
  { Header: "ocit_o_checksum", accessor: "ocit_o_checksum" },
  {
   Header: "Status",
   Cell: ({ row }: any) => (
    <div className="flex justify-center">
     <svg
      className="cursor-pointer"
      onClick={() => {
       popHandler(row?.id)
      }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
     >
      <g id="Iconly/Light-Outline/Danger Circle">
       <g id="Danger Circle">
        <path
         id="Fill 1"
         fillRule="evenodd"
         clipRule="evenodd"
         d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
         // fill="#111928"
        />
        <path
         id="Fill 3"
         fillRule="evenodd"
         clipRule="evenodd"
         d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
         // fill="#111928"
        />
        <path
         id="Fill 5"
         fillRule="evenodd"
         clipRule="evenodd"
         d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
         // fill="#111928"
        />
       </g>
      </g>
     </svg>
    </div>
   ),
  },
 ]

 const popHandler = (id: number) => {
  setPopup(true)

  const newData = selectedData?.find((item, index) => index === Number(id))
  setModelData(newData)
 }
 useEffect(() => {
  if (data) {
   setAllData(data)
   const _notificationPointElement: any[] = []

   const currentObj = data?.find((item, index) => index === currentIndex)
   setServerDeviceName(
    currentObj?.common_information?.server_name +
     ": " +
     currentObj?.common_information?.device_name,
   )
   _notificationPointElement.push(currentObj?.notification_point_element)

   setSelectedData(_notificationPointElement[0])
   setCurrentData(_notificationPointElement[0])
   setModelData(_notificationPointElement[0])
  }

  // eslint-disable-next-line
 }, [data, currentIndex])
 const searchHandler = (keyword: any) => {
  if (keyword !== "") {
   const filterData: any = currentData?.filter((item) => {
    const itemString = String(item?.total_version_buildnumber).toLowerCase()
    return itemString.indexOf(keyword.toLowerCase()) !== -1
   })
   setSelectedData([...filterData])
  } else {
   setSelectedData(currentData)
  }
 }

 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full">
   <TableModelRow
    data={modelData?.details && modelData?.details}
    popup={popup}
    setPopup={setPopup}
    serverDeviceName={serverDeviceName}
   />
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("supplyData")}</h1>
    <div className="flex lg:w-[6%] justify-between">
     <button className="bg-white h-6 w-6 rounded-lg flex items-center justify-center ">
      <img className="rotate-[-90deg]" src={selectIcon} alt="prev" />
     </button>
     <button className="bg-white h-6 w-6 rounded-lg flex items-center justify-center ">
      <img className="rotate-90" src={selectIcon} alt="next" />
     </button>
    </div>
   </div>
   <Box bg="highlight" color="text-black">
    <ul className="flex rounded w-[100%] Jakarta-font overflow-x-scroll hide-scroll-icon">
     {allData &&
      allData?.map((single, index) => (
       <li
        key={index}
        className={`text-xs bg-light-gray2 text-black opacity-70 cursor-pointer rounded px-2 py-3 lg:px-4 md:px-4 whitespace-nowrap ${
         currentIndex === index ? "bg-white rounded font-bold" : ""
        }`}
        onClick={() => {
         setCurrentIndex(index)
        }}
       >
        {single?.common_information?.server_name} + {single?.common_information?.device_name}
       </li>
      ))}
    </ul>
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">Testserver: Testanlage 01 Gera</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">Category</p>

      <div className="bg-white h-8 w-12 rounded mx-4  border-light-gray border-[1.5px] flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder={t("search")}
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
    isLoading={isLoading}
   />
  </div>
 )
}
